import registrationTypeServices from '@/api/administrative/registrationTypeServices'
import tipoFaixaServices from '@/api/financial/tipoFaixaServices'
import comboServices from '@/api/combo/comboServices'

export default {
  loadTable({ commit }, pageConfig) {
    return registrationTypeServices.loadTable(pageConfig).then(result => {
      commit('LOAD_LIST_REGISTRATION_TYPE', result.data.content)
      return result
    }).catch(err => err)
  },
  insertNewRegistrationType({ commit }, data) {
    return registrationTypeServices.insertNewRegistrationType(data)
  },
  prepareToEditRegistrationType({ commit }, data) {
    commit('PREPARE_TO_EDIT_REGISTRATION_TYPE', data)
  },
  editRegistrationType({ commit }, data) {
    return registrationTypeServices.editRegistrationType(data)
  },
  resetRegistrationType({ commit }) {
    commit('RESET_REGISTRATION_TYPE')
  },
  loadComboType({ commit }) {
    return new Promise((resolve, reject) => registrationTypeServices.loadCombo().then(result => {
      commit('SET_LIST_COMBO_TYPE', result.data)
      resolve(result)
    }).catch(err => reject(err)))
  },
  loadComboTipoFaixa({ commit }) {
    return new Promise((resolve, reject) => tipoFaixaServices.loadCombo().then(result => {
      commit('SET_COMBO_TIPO_FAIXA', result.data)
      resolve(result)
    }).catch(err => reject(err)))
  },
  loadComboTipoPagamento({ commit }) {
    return new Promise((resolve, reject) => comboServices.loadComboTipoPagamento().then(result => {
      commit('SET_COMBO_TIPO_PAGAMENTO', result.data)
      resolve(result)
    }).catch(err => reject(err)))
  },
  loadComboContas({ commit }) {
    return new Promise((resolve, reject) => comboServices.loadComboContas().then(result => {
      commit('SET_COMBO_CONTAS', result.data)
      resolve(result)
    }).catch(err => reject(err)))
  },
  delete({ commit }, id) {
    return registrationTypeServices.deleteRegistrationType(id)
  },
}
